'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.InputMode = exports.InputType = void 0;
var InputType;
(function (InputType) {
    InputType["TEXT"] = "text";
    InputType["PASSWORD"] = "password";
    InputType["NUMBER"] = "number";
})(InputType = exports.InputType || (exports.InputType = {}));
var InputMode;
(function (InputMode) {
    InputMode["NUMERIC"] = "numeric";
})(InputMode = exports.InputMode || (exports.InputMode = {}));
